// Author YuJiaBei
// Date 2020-08-10 09:06:39

class EmMaMaintenanceCat {
constructor({
        id = null,
        name = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.remark = remark;
}
}

function newEntity() {
return new EmMaMaintenanceCat();
}

function gridFields() {
return Object.freeze([
        {
        key: 'name',
        label: 'label.em.maintenance.emMaMaintenanceCat.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.maintenance.emMaMaintenanceCat.grid.remark',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    nameFilter : "",
    remarkFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.em.maintenance.emMaMaintenanceCat.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remarkFilter',
        label: 'label.em.maintenance.emMaMaintenanceCat.filter.remark',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.em.maintenance.emMaMaintenanceCat.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.maintenance.emMaMaintenanceCat.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {EmMaMaintenanceCat, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
